import { isMultiAccountReport } from 'reporting-data/tsTypes/reportTypes';
// @ts-expect-error untyped import
import { useHasMultiAccountOrgConfigViewScope } from '../../access/scopes/hooks/useHasScope';
import { useIsUngatedForMultiAccountReporting } from '../../access/gates/hooks/useGate';
import { useGetCurrentUserOrganizationAccessQuery } from '../../../__generated__/chirp/com/hubspot/multi/account/configuration/manager/rpc/MultiAccountOrganizationChirpService.hooks';
export const useCheckOrgAdminAccess = report => {
  const isUngatedForMultiAccountReporting = useIsUngatedForMultiAccountReporting();
  const hasMAConfigScope = useHasMultiAccountOrgConfigViewScope();
  const isMAReport = report && isMultiAccountReport(report);
  const requiresOrgAdminAccess = isUngatedForMultiAccountReporting && isMAReport;
  const {
    data,
    error,
    loading
  } = useGetCurrentUserOrganizationAccessQuery({
    skip: !requiresOrgAdminAccess || !hasMAConfigScope
  });
  const hasOrgAdminAccess = (data === null || data === void 0 ? void 0 : data.organizationAdmin) || false;
  const lacksRequiredOrgAdminAccess = requiresOrgAdminAccess && !hasOrgAdminAccess;
  return {
    data: lacksRequiredOrgAdminAccess,
    error,
    loading
  };
};